import { render, staticRenderFns } from "./thirdCompanySelect.vue?vue&type=template&id=a4b55e8c&scoped=true&"
import script from "./thirdCompanySelect.vue?vue&type=script&lang=js&"
export * from "./thirdCompanySelect.vue?vue&type=script&lang=js&"
import style0 from "./thirdCompanySelect.vue?vue&type=style&index=0&id=a4b55e8c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b55e8c",
  null
  
)

export default component.exports